<!-- 巨量引擎 计划 表格 -->
<template>
	<div class="table-box" >
		<!-- 表头 -->
		<div class="table-th" ref="table_th" :style="{'width': table_scroll_width + 'px'}">
			<div class="table-th-cell-sticky" style="display: flex;align-items: center;">
				<div class="table-th-cell"
				:style="{'width':30 + 'px'}">
					<a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange"></a-checkbox>
				</div>
				
				<template v-for="(item,index) in rableTitle" name="item.type">
					<div v-if="index <= sticky_index" class="table-th-cell" style="cursor: default;"
					:style="{'width':rableTitle[index].width + 'px'}" >
						{{rableTitle[index].title}}
					</div>
				</template>
			</div>
			
			<div  v-for="(item,index) in rableTitle" :key="index" >
	
				<div v-if="index > sticky_index && item.show_control" class="table-th-cell" 
				:style="{'width':item.width + 'px','cursor':item.sort_control?'pointer':'default','justify-content': item.text_right?'flex-end':''}"
				@click="sortClick(index)">
					{{item.title}}
					<div v-if="item.sort_control" style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
						<a-icon type="caret-up" :style="{'color': item.sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
						<a-icon type="caret-down" :style="{'color': item.sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
					</div>
				</div>
			</div>
			<!-- 占位，隔出一个空白区域 -->
			<div id="" style="padding:15px;"></div>
		</div>
		
		<!-- 总计 -->
		<div v-if="tableShowData.length > 0" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div class="table-td-cell-sticky" style="display: flex;align-items: center;">
				<!-- 选择 -->
				<div class="table-td-cell" :style="{'width':30 + 'px'}">
					
				</div>
				
				<template v-for="(z_tem,z_ndex) in rableTitle">
					<div v-if="z_ndex <= sticky_index && z_ndex == 0" class="table-td-cell"
					:style="{'width':rableTitle[z_ndex].width + 'px'}">
						总计
					</div>
					<div v-else-if="z_ndex <= sticky_index" class="table-td-cell"
					:style="{'width':rableTitle[z_ndex].width + 'px'}">
						
					</div>
				</template>
			</div>
			<template v-for="(z_tem,z_ndex) in rableTitle">
				<div v-if="z_ndex > sticky_index && z_tem.show_control && z_table_control.indexOf(z_tem.type) < 0 && b_table_control.indexOf(z_tem.type) < 0 && x_table_control.indexOf(z_tem.type) < 0 " class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{tableSumData[z_tem.type] || 0}}
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_table_control.indexOf(z_tem.type) > -1" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && b_table_control.indexOf(z_tem.type) > -1" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{tableSumData[z_tem.type]*100 | tableToFixed}}%
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && x_table_control.indexOf(z_tem.type) > -1" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{tableSumData[z_tem.type] | tableToFixed}}
				</div>
			</template>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="item.id" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div class="table-td-cell-sticky" style="display: flex;align-items: center;">
				<!-- 选择 -->
				<div class="table-td-cell" :style="{'width':30 + 'px'}">
					<a-checkbox :checked="item.checked" @change="onChangeCheckbox($event,index)"></a-checkbox>
				</div>
				
				<template v-for="(z_tem,z_ndex) in rableTitle">
					<div v-if="z_ndex <= sticky_index && z_tem.type == 'name'"  
					@click='operation(1,item)' class="table-td-cell"
					:style="{'width':rableTitle[z_ndex].width + 'px'}"
					 style="color: #2F88FF;cursor: pointer;">
						{{item[z_tem.type]}}
					</div>
					
					<div v-else-if="z_ndex <= sticky_index && z_tem.type == 'cz'"  
					class="table-td-cell" style="display: flex;align-items: center;"
					:style="{'width':rableTitle[z_ndex].width + 'px'}">
						<a-switch size="small" :checked="item.status_checked" default-checked @change="onStatusCheckbox($event,item)"  checked-children="启用" un-checked-children="暂停"/>
						
						<!-- <a-popover :visible="item.popover_clicked" @visibleChange="handleClickChange($event,item)" trigger="click" placement="bottom"> -->
							<!-- <template slot="content">
							  <div>
								  <div @click="zhOperation(5,item)" class='cz-button-calss'>复制</div>
								  <div @click="zhOperation(1,item)" class='cz-button-calss'>编辑</div>
								  <div @click="zhOperation(2,item)" class='cz-button-calss'>新建回传比例任务</div>
								  <div @click="zhOperation(3,item)" class='cz-button-calss'>新建出价任务</div>
								  <div @click="zhOperation(7,item)" class='cz-button-calss'>管理出价任务</div>
							  </div>
							</template> -->
							
							<a-icon style="font-size: 18px;font-weight: bold;cursor: pointer;margin-left: 7px;" type="more" />
						<!-- </a-popover> -->
					</div>
					
				</template>
			</div>
			
			<template v-for="(z_tem,z_ndex) in rableTitle">
				<div v-if="z_ndex > sticky_index && z_tem.show_control && y_table_control.indexOf(z_tem.type) < 0 && b_table_control.indexOf(z_tem.type) < 0 && x_table_control.indexOf(z_tem.type) < 0 && z_tem.type != 'admin_list'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type] || 0}}
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && b_table_control.indexOf(z_tem.type) > -1" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type]*100 | tableToFixed}}%
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && x_table_control.indexOf(z_tem.type) > -1" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type] | tableToFixed}}
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && y_table_control.indexOf(z_tem.type) > -1" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type]}}
				</div>
				<!-- 投手 -->
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'admin_list'" 
				class="table-td-cell" :style="{'width': rableTitle[z_ndex].width + 'px'}">
					<div v-if="item.admin_list.length > 0" style="display: flex;align-items: center;flex-wrap: wrap;">
						<div v-for="(item,index) in item.admin_list" :key="index" style="margin: 0 10px 5px 0;">
							{{item.admin_name}}
						</div>
					</div>
				</div>
			</template>
			
		</div>
		
		
		<div v-show="tableShowData.length === 0" style="text-align: center;margin: 80px 0 50px;" :style="{'width': table_null_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		
		<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		
		
	</div>
</template>

<script>
export default {
	name: 'JLprojectTable',
	props: ['rableTitle','tableShowData','tableSumData','table_scroll_width','jj_checked','indeterminate','checkAll','table_null_width'],
	data(){
		return {
			
			select_sort_index: "", // 筛选的
			
			popover_clicked: false,
			
			sticky_index: 1,
			// 用于总计的不显示控制
			z_table_control: ['project_id','adv_name','advertiser_id','project_create_time','project_modify_time','admin_list'],
		
			// 表格项要进行百分比展示的
			b_table_control: ['eff_roi','eff_roi_first'],
			// 表格项要进行小数点后两位
			x_table_control: ['active_cost','lp_price','eff_total_pay_user_cost','arpu','eff_report_pay_user_cost'],
			// 表格项不进行任何处理直接展示的-一般为文字内容
			y_table_control: ['project_id','adv_name','advertiser_id','project_create_time','project_modify_time'],
		}
	},
	methods: {
		sortClick(index){ // 点击表头给内容进行排序
			let that = this
			let th_status // 0是默认，1是箭头向下，2是箭头向上
			console.log(that.rableTitle[index].type)
			if(that.rableTitle[index].sort_control){ // 是否有排序功能
				if(index !== this.select_sort_index){
					this.select_sort_index = index
					that.rableTitle.forEach(res=>{
						res.sort_status = 0
					})
					that.rableTitle[index].sort_status = 1
					th_status = 1
				}
				else { // 点击的是同一个表头
					if(that.rableTitle[index].sort_status === 0){
						that.rableTitle[index].sort_status = 1 // 箭头向下
						th_status = 1
					}
					else if(that.rableTitle[index].sort_status === 1){
						that.rableTitle[index].sort_status = 2 // 箭头向上
						th_status = 2
					}
					else if(that.rableTitle[index].sort_status === 2){
						that.rableTitle[index].sort_status = 0
						th_status = 0
					}
				}
				
				this.$emit('table-th-click', index, th_status, that.rableTitle[index].type)
			}
		},
		// editTable(index){
		// 	this.$emit('edit-td-click', index)
		// },
		
		// 操作
		operation(e,item){
			console.log(e,item)
			if(e == 1){ // 点击账户名称
				// 这里使用params方式传参，而不用query是因为，params的参数不会拼在url后面，这样子刷新页面后，传过来的参数就可以自动清空
				this.$router.push({name: 'JLpromotion_',params: {jump_name: item.name}})
			}
			
		},
		handleClickChange(e,item){
			console.log(e)
			item.popover_clicked = e
		},
		// 表格内的操作项
		zhOperation(e,item){
			console.log(item);
			if(e == 1){ // 同步账户信息
				item.popover_clicked = false
				this.$emit('sync-zhxx-click', item)
			}
			else if(e == 2){ // 查看广告组
				
			}
			else if(e == 2){ // 查看计划
				
			}
		},
		
		// 全选
		onCheckAllChange(e){
			this.$emit('click-All-Checkbox', e)
		},
		// 单选
		onChangeCheckbox(checkedList,index){
			this.$emit('click-Checkbox', checkedList,index)
		},
		
		// 操作项的开关
		onStatusCheckbox(e,item){ // 启用或暂停
			// console.log(e,item);
			// this.$emit('status-Checkbox', e, item)
		},
		
	},
	filters: {
		tableToFixed(value){ // 保留小数点后两位，四舍五入
			// console.log("过滤器",value)
			if(value){
				let v = Number(value)
				return v.toFixed(2)
			}
			else {
				return 0
			}
			
		}
	}
}
</script>

<style scoped>
.cz-button-calss {
	font-size: 13px;
	padding:10px;
	cursor: pointer;
}
.cz-button-calss:hover {
	background-color: #f4f7fa;
}

/* 表格样式-非公共/基础样式 */
.table-th-cell {
	height: 59px;
}
.table-th-cell:hover {
	background-color: #eee;
}
.table-th-cell:hover .table-th-cell-sticky{
	background-color: #eee;
}

.table-td-cell {
	font-size: 12px;
}
</style>